"use strict";

var _slicedToArray = require("/Users/zero/localdev/personal/byoungz-gatsby/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _classCallCheck = require("/Users/zero/localdev/personal/byoungz-gatsby/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/zero/localdev/personal/byoungz-gatsby/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Particles = void 0;

var Particle_1 = require("./Particle");

var Utils_1 = require("../Utils");

var ParticlesOptions_1 = require("../Options/Classes/Particles/ParticlesOptions");

var Utils_2 = require("./Utils");

var Particles = /*#__PURE__*/function () {
  function Particles(container) {
    _classCallCheck(this, Particles);

    this.container = container;
    this.nextId = 0;
    this.array = [];
    this.zArray = [];
    this.mover = new Utils_2.ParticlesMover(container);
    this.limit = 0;
    this.needsSort = false;
    this.lastZIndex = 0;
    this.freqs = {
      links: new Map(),
      triangles: new Map()
    };
    this.interactionManager = new Utils_2.InteractionManager(container);
    var canvasSize = this.container.canvas.size;
    this.linksColors = new Map();
    this.quadTree = new Utils_2.QuadTree(new Utils_2.Rectangle(-canvasSize.width / 4, -canvasSize.height / 4, canvasSize.width * 3 / 2, canvasSize.height * 3 / 2), 4);
    this.updaters = Utils_2.Plugins.getUpdaters(container, true);
  }

  _createClass(Particles, [{
    key: "count",
    get: function get() {
      return this.array.length;
    }
  }, {
    key: "init",
    value: function init() {
      var _a;

      var container = this.container;
      var options = container.actualOptions;
      this.lastZIndex = 0;
      this.needsSort = false;
      this.freqs.links = new Map();
      this.freqs.triangles = new Map();
      var handled = false;
      this.updaters = Utils_2.Plugins.getUpdaters(container, true);
      this.interactionManager.init();

      var _iterator = _createForOfIteratorHelper(container.plugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              plugin = _step$value[1];

          if (plugin.particlesInitialization !== undefined) {
            handled = plugin.particlesInitialization();
          }

          if (handled) {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.addManualParticles();

      if (!handled) {
        for (var group in options.particles.groups) {
          var groupOptions = options.particles.groups[group];

          for (var i = this.count, j = 0; j < ((_a = groupOptions.number) === null || _a === void 0 ? void 0 : _a.value) && i < options.particles.number.value; i++, j++) {
            this.addParticle(undefined, groupOptions, group);
          }
        }

        for (var _i = this.count; _i < options.particles.number.value; _i++) {
          this.addParticle();
        }
      }

      container.pathGenerator.init(container);
    }
  }, {
    key: "redraw",
    value: function redraw() {
      this.clear();
      this.init();
      this.draw({
        value: 0,
        factor: 0
      });
    }
  }, {
    key: "removeAt",
    value: function removeAt(index) {
      var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var group = arguments.length > 2 ? arguments[2] : undefined;
      var override = arguments.length > 3 ? arguments[3] : undefined;

      if (!(index >= 0 && index <= this.count)) {
        return;
      }

      var deleted = 0;

      for (var i = index; deleted < quantity && i < this.count; i++) {
        var particle = this.array[i];

        if (!particle || particle.group !== group) {
          continue;
        }

        particle.destroy(override);
        this.array.splice(i--, 1);
        var zIdx = this.zArray.indexOf(particle);
        this.zArray.splice(zIdx, 1);
        deleted++;
      }
    }
  }, {
    key: "remove",
    value: function remove(particle, group, override) {
      this.removeAt(this.array.indexOf(particle), undefined, group, override);
    }
  }, {
    key: "update",
    value: function update(delta) {
      var container = this.container;
      var particlesToDelete = [];
      container.pathGenerator.update();

      var _iterator2 = _createForOfIteratorHelper(container.plugins),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              plugin = _step2$value[1];

          if (plugin.update !== undefined) {
            plugin.update(delta);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(this.array),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _particle = _step3.value;
          var resizeFactor = container.canvas.resizeFactor;

          if (resizeFactor) {
            _particle.position.x *= resizeFactor.width;
            _particle.position.y *= resizeFactor.height;
          }

          _particle.bubble.inRange = false;

          var _iterator5 = _createForOfIteratorHelper(this.container.plugins),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _step5$value = _slicedToArray(_step5.value, 2),
                  _plugin = _step5$value[1];

              if (_particle.destroyed) {
                break;
              }

              if (_plugin.particleUpdate) {
                _plugin.particleUpdate(_particle, delta);
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          this.mover.move(_particle, delta);

          if (_particle.destroyed) {
            particlesToDelete.push(_particle);
            continue;
          }

          this.quadTree.insert(new Utils_2.Point(_particle.getPosition(), _particle));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      for (var _i2 = 0, _particlesToDelete = particlesToDelete; _i2 < _particlesToDelete.length; _i2++) {
        var particle = _particlesToDelete[_i2];
        this.remove(particle);
      }

      this.interactionManager.externalInteract(delta);

      var _iterator4 = _createForOfIteratorHelper(container.particles.array),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _particle2 = _step4.value;

          var _iterator6 = _createForOfIteratorHelper(this.updaters),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var updater = _step6.value;
              updater.update(_particle2, delta);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          if (!_particle2.destroyed && !_particle2.spawning) {
            this.interactionManager.particlesInteract(_particle2, delta);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      delete container.canvas.resizeFactor;
    }
  }, {
    key: "draw",
    value: function draw(delta) {
      var container = this.container;
      container.canvas.clear();
      var canvasSize = this.container.canvas.size;
      this.quadTree = new Utils_2.QuadTree(new Utils_2.Rectangle(-canvasSize.width / 4, -canvasSize.height / 4, canvasSize.width * 3 / 2, canvasSize.height * 3 / 2), 4);
      this.update(delta);

      if (this.needsSort) {
        this.zArray.sort(function (a, b) {
          return b.position.z - a.position.z || a.id - b.id;
        });
        this.lastZIndex = this.zArray[this.zArray.length - 1].position.z;
        this.needsSort = false;
      }

      var _iterator7 = _createForOfIteratorHelper(container.plugins),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _step7$value = _slicedToArray(_step7.value, 2),
              plugin = _step7$value[1];

          container.canvas.drawPlugin(plugin, delta);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      var _iterator8 = _createForOfIteratorHelper(this.zArray),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var p = _step8.value;
          p.draw(delta);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.array = [];
      this.zArray = [];
    }
  }, {
    key: "push",
    value: function push(nb, mouse, overrideOptions, group) {
      this.pushing = true;

      for (var i = 0; i < nb; i++) {
        this.addParticle(mouse === null || mouse === void 0 ? void 0 : mouse.position, overrideOptions, group);
      }

      this.pushing = false;
    }
  }, {
    key: "addParticle",
    value: function addParticle(position, overrideOptions, group) {
      var container = this.container,
          options = container.actualOptions,
          limit = options.particles.number.limit * container.density;

      if (limit > 0) {
        var countToRemove = this.count + 1 - limit;

        if (countToRemove > 0) {
          this.removeQuantity(countToRemove);
        }
      }

      return this.pushParticle(position, overrideOptions, group);
    }
  }, {
    key: "addSplitParticle",
    value: function addSplitParticle(parent) {
      var splitOptions = parent.options.destroy.split,
          options = new ParticlesOptions_1.ParticlesOptions();
      options.load(parent.options);
      var factor = (0, Utils_1.getRangeValue)(splitOptions.factor.value);
      options.color.load({
        value: {
          hsl: parent.getFillColor()
        }
      });

      if (typeof options.size.value === "number") {
        options.size.value /= factor;
      } else {
        options.size.value.min /= factor;
        options.size.value.max /= factor;
      }

      options.load(splitOptions.particles);
      var offset = splitOptions.sizeOffset ? (0, Utils_1.setRangeValue)(-parent.size.value, parent.size.value) : 0;
      var position = {
        x: parent.position.x + (0, Utils_1.randomInRange)(offset),
        y: parent.position.y + (0, Utils_1.randomInRange)(offset)
      };
      return this.pushParticle(position, options, parent.group, function (particle) {
        if (particle.size.value < 0.5) {
          return false;
        }

        particle.velocity.length = (0, Utils_1.randomInRange)((0, Utils_1.setRangeValue)(parent.velocity.length, particle.velocity.length));
        particle.splitCount = parent.splitCount + 1;
        particle.unbreakable = true;
        setTimeout(function () {
          particle.unbreakable = false;
        }, 500);
        return true;
      });
    }
  }, {
    key: "removeQuantity",
    value: function removeQuantity(quantity, group) {
      this.removeAt(0, quantity, group);
    }
  }, {
    key: "getLinkFrequency",
    value: function getLinkFrequency(p1, p2) {
      var range = (0, Utils_1.setRangeValue)(p1.id, p2.id),
          key = "".concat((0, Utils_1.getRangeMin)(range), "_").concat((0, Utils_1.getRangeMax)(range));
      var res = this.freqs.links.get(key);

      if (res === undefined) {
        res = Math.random();
        this.freqs.links.set(key, res);
      }

      return res;
    }
  }, {
    key: "getTriangleFrequency",
    value: function getTriangleFrequency(p1, p2, p3) {
      var _ref = [p1.id, p2.id, p3.id],
          id1 = _ref[0],
          id2 = _ref[1],
          id3 = _ref[2];

      if (id1 > id2) {
        var _ref2 = [id1, id2];
        id2 = _ref2[0];
        id1 = _ref2[1];
      }

      if (id2 > id3) {
        var _ref3 = [id2, id3];
        id3 = _ref3[0];
        id2 = _ref3[1];
      }

      if (id1 > id3) {
        var _ref4 = [id1, id3];
        id3 = _ref4[0];
        id1 = _ref4[1];
      }

      var key = "".concat(id1, "_").concat(id2, "_").concat(id3);
      var res = this.freqs.triangles.get(key);

      if (res === undefined) {
        res = Math.random();
        this.freqs.triangles.set(key, res);
      }

      return res;
    }
  }, {
    key: "addManualParticles",
    value: function addManualParticles() {
      var container = this.container,
          options = container.actualOptions;

      var _iterator9 = _createForOfIteratorHelper(options.manualParticles),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var particle = _step9.value;
          var pos = particle.position ? {
            x: particle.position.x * container.canvas.size.width / 100,
            y: particle.position.y * container.canvas.size.height / 100
          } : undefined;
          this.addParticle(pos, particle.options);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  }, {
    key: "setDensity",
    value: function setDensity() {
      var options = this.container.actualOptions;

      for (var group in options.particles.groups) {
        this.applyDensity(options.particles.groups[group], 0, group);
      }

      this.applyDensity(options.particles, options.manualParticles.length);
    }
  }, {
    key: "applyDensity",
    value: function applyDensity(options, manualCount, group) {
      var _a;

      if (!((_a = options.number.density) === null || _a === void 0 ? void 0 : _a.enable)) {
        return;
      }

      var numberOptions = options.number;
      var densityFactor = this.initDensityFactor(numberOptions.density);
      var optParticlesNumber = numberOptions.value;
      var optParticlesLimit = numberOptions.limit > 0 ? numberOptions.limit : optParticlesNumber;
      var particlesNumber = Math.min(optParticlesNumber, optParticlesLimit) * densityFactor + manualCount;
      var particlesCount = Math.min(this.count, this.array.filter(function (t) {
        return t.group === group;
      }).length);
      this.limit = numberOptions.limit * densityFactor;

      if (particlesCount < particlesNumber) {
        this.push(Math.abs(particlesNumber - particlesCount), undefined, options, group);
      } else if (particlesCount > particlesNumber) {
        this.removeQuantity(particlesCount - particlesNumber, group);
      }
    }
  }, {
    key: "initDensityFactor",
    value: function initDensityFactor(densityOptions) {
      var container = this.container;

      if (!container.canvas.element || !densityOptions.enable) {
        return 1;
      }

      var canvas = container.canvas.element,
          pxRatio = container.retina.pixelRatio;
      return canvas.width * canvas.height / (densityOptions.factor * Math.pow(pxRatio, 2) * densityOptions.area);
    }
  }, {
    key: "pushParticle",
    value: function pushParticle(position, overrideOptions, group, initializer) {
      try {
        var particle = new Particle_1.Particle(this.nextId, this.container, position, overrideOptions, group);
        var canAdd = true;

        if (initializer) {
          canAdd = initializer(particle);
        }

        if (!canAdd) {
          return;
        }

        this.array.push(particle);
        this.zArray.push(particle);
        this.nextId++;
        return particle;
      } catch (e) {
        console.warn("error adding particle: ".concat(e));
        return;
      }
    }
  }]);

  return Particles;
}();

exports.Particles = Particles;